export function toFullS3Url(imageKeyOrFullUrl: string) {
  if (/^(https?:\/\/|data:|blob:)/.test(imageKeyOrFullUrl)) {
    return imageKeyOrFullUrl;
  }
  return `https://happiscreen.s3.us-west-1.amazonaws.com/${imageKeyOrFullUrl}`;
}
